export const BREAKPOINT_SMALL = 640;
export const BREAKPOINT_MEDIUM = 960;
export const BREAKPOINT_LARGE = 1200;
export const BREAKPOINT_XLARGE = 1600;
